import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { Heading } from 'components/typography';
import type React from 'react';
import ChatBotSpaceHolder, { CHAT_BOT_HEIGHT } from './ChatBotSpaceHolder';
import { useTheme } from '@mui/material/styles';
interface DocumentDesignSettingsProps {
  menuTitle: string;
  backButtonOnClick: () => void;
  children: React.ReactNode;
  testId?: string;
  rowGap?: string;
}

export default function SecondaryMenu({ rowGap = '20px', menuTitle, children, backButtonOnClick, testId }: DocumentDesignSettingsProps) {
  const theme = useTheme();
  return (
    <Grid className="secondary-menu" container mt={2} data-testid={testId} rowGap="16px">
      <Grid container justifyContent="space-between" alignItems="center">
        <IconButton data-testid="side-panel-back-button" size="small" onClick={backButtonOnClick}>
          <ArrowBackIosNewIcon fontSize="inherit" />
        </IconButton>
        <Grid flex={1} ml={1}>
          <Heading level={5} style={{ marginBlock: 0 }}>
            {menuTitle}
          </Heading>
        </Grid>
      </Grid>
      <Grid rowGap={rowGap} container alignItems="center" justifyContent="start" sx={{ paddingBottom: CHAT_BOT_HEIGHT }}>
        {children}
      </Grid>
      <Grid position="fixed" bottom="0" zIndex={theme.zIndex.appBar} width={'100%'}>
        <ChatBotSpaceHolder />
      </Grid>
    </Grid>
  );
}
